import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ElementRef, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FooterComponent, HeaderComponent, BreadcrumbComponent, NavigationComponent, ModalComponentModule, NavigationService } from './sharedindex';
import { NgxLoadingModule } from 'ngx-loading';
import { Routes, RouterModule } from '@angular/router';
import { Router, ActivatedRoute } from "@angular/router";
import { APP_ROUTER_PROVIDERS } from "../app.routes";

@NgModule({
    imports: [CommonModule, FormsModule, RouterModule, NgxLoadingModule, ModalComponentModule],
    declarations: [HeaderComponent, FooterComponent, BreadcrumbComponent, NavigationComponent],
    exports: [HeaderComponent, FooterComponent, BreadcrumbComponent, NavigationComponent, ModalComponentModule],
    providers: [NavigationService]
})
export class MentisSoftSharedModule {
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/shared.module.ts